module.exports = __webpack_public_path__ + "static/img/4.37201f9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/zh/4.png
// module id = hQ37
// module chunks = 0